import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFakeAssets } from '../../Mock/fakebackend_helper';
import Agent from '../agent';
import config from '../../config';
// import { get } from "http";

const isMockEnable = config.enableMock;

const initialState = {
  loading: false,
  assets: [],
  errors: {},
  redirectTo: null,
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getAssets = createAsyncThunk('assets/get', async (data, { rejectWithValue }) => {
  try {
    let res;
    if (isMockEnable) {
      res = (await getFakeAssets()).data;
    } else {
      res = await Agent.Auth.login(data.username, data.password);
    }
    return res;
  } catch (err) {
    let error = err;
    if (!error.response) {
      return rejectWithValue({ errors: { [err.name]: err.message } });
    }
    return rejectWithValue(error.response.body);
  }
});

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
    updateUserState(state, action) {
      if (state.errors[action.payload.key]) delete state.errors[action.payload.key];
      state.user[action.payload.key] = action.payload.value;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getAssets.pending]: (state) => {
      state.loading = true;
    },

    [getAssets.fulfilled]: (state, action) => {
      state.loading = false;
      state.assets = action?.payload || [];
    },

    [getAssets.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const assetsSelector = (state) => state.assets;

export const { reducer, actions } = assetsSlice;
